import { createStorageManager } from "app/pages/sales-intelligence/services/storage-manager/factory";

const sessionStorageManager = createStorageManager(window.sessionStorage, (key) => `si:apps-search:${key}`);

export const appsSearchSessionStorage = sessionStorageManager.configList({
    appsFeatureRequestSent: { key: "apps-feature-request-sent", defaultValue: false },
    sdkColumnHookSubmitted: { key: "sdk-column-hook-submitted", defaultValue: false },
    sdkFilterHookSubmitted: { key: "sdk-filter-hook-submitted", defaultValue: false },
});
